/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from "./core/BaseHttpRequest";
import type { OpenAPIConfig } from "./core/OpenAPI";
import { AxiosHttpRequest } from "./core/AxiosHttpRequest";

import { AutolineAppService } from "./services/AutolineAppService";
import { AutoShoppingAppService } from "./services/AutoShoppingAppService";
import { CacheAppService } from "./services/CacheAppService";
import { CarroSpAppService } from "./services/CarroSpAppService";
import { ChavesNaMaoAppService } from "./services/ChavesNaMaoAppService";
import { ConfigurationAppService } from "./services/ConfigurationAppService";
import { ContractsAppService } from "./services/ContractsAppService";
import { CredentialsAppService } from "./services/CredentialsAppService";
import { DashboardAppService } from "./services/DashboardAppService";
import { EntityAppService } from "./services/EntityAppService";
import { EntityAdditionalInfosAppService } from "./services/EntityAdditionalInfosAppService";
import { EntityDocumentAppService } from "./services/EntityDocumentAppService";
import { FacebookAppService } from "./services/FacebookAppService";
import { FinancialCategoryAppService } from "./services/FinancialCategoryAppService";
import { FinancialMovementAppService } from "./services/FinancialMovementAppService";
import { ICarrosAppService } from "./services/ICarrosAppService";
import { MercadoLivreAppService } from "./services/MercadoLivreAppService";
import { MobiautoAppService } from "./services/MobiautoAppService";
import { NetMotorsAppService } from "./services/NetMotorsAppService";
import { OlxAppService } from "./services/OlxAppService";
import { PermissionsAppService } from "./services/PermissionsAppService";
import { PortalsAppService } from "./services/PortalsAppService";
import { PremiumAppService } from "./services/PremiumAppService";
import { RoleAppService } from "./services/RoleAppService";
import { SalaoDoCarroAppService } from "./services/SalaoDoCarroAppService";
import { SessionAppService } from "./services/SessionAppService";
import { SoCarraoAppService } from "./services/SoCarraoAppService";
import { TagsAppService } from "./services/TagsAppService";
import { TokenAuthAppService } from "./services/TokenAuthAppService";
import { UserAppService } from "./services/UserAppService";
import { VehicleAdsAppService } from "./services/VehicleAdsAppService";
import { VehicleDocumentAppService } from "./services/VehicleDocumentAppService";
import { VehicleExpensesAppService } from "./services/VehicleExpensesAppService";
import { VehicleImageAppService } from "./services/VehicleImageAppService";
import { VehicleInternalObservationsAppService } from "./services/VehicleInternalObservationsAppService";
import { VehicleManagementInfosAppService } from "./services/VehicleManagementInfosAppService";
import { VehiclesAppService } from "./services/VehiclesAppService";
import { VehicleSaleAppService } from "./services/VehicleSaleAppService";
import { VendorsAppService } from "./services/VendorsAppService";

type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;

export class IntegradorClient {
  public readonly autoline: AutolineAppService;
  public readonly autoShopping: AutoShoppingAppService;
  public readonly cache: CacheAppService;
  public readonly carroSp: CarroSpAppService;
  public readonly chavesNaMao: ChavesNaMaoAppService;
  public readonly configuration: ConfigurationAppService;
  public readonly contracts: ContractsAppService;
  public readonly credentials: CredentialsAppService;
  public readonly dashboard: DashboardAppService;
  public readonly entity: EntityAppService;
  public readonly entityAdditionalInfos: EntityAdditionalInfosAppService;
  public readonly entityDocument: EntityDocumentAppService;
  public readonly facebook: FacebookAppService;
  public readonly financialCategory: FinancialCategoryAppService;
  public readonly financialMovement: FinancialMovementAppService;
  public readonly iCarros: ICarrosAppService;
  public readonly mercadoLivre: MercadoLivreAppService;
  public readonly mobiauto: MobiautoAppService;
  public readonly netMotors: NetMotorsAppService;
  public readonly olx: OlxAppService;
  public readonly permissions: PermissionsAppService;
  public readonly portals: PortalsAppService;
  public readonly premium: PremiumAppService;
  public readonly role: RoleAppService;
  public readonly salaoDoCarro: SalaoDoCarroAppService;
  public readonly session: SessionAppService;
  public readonly soCarrao: SoCarraoAppService;
  public readonly tags: TagsAppService;
  public readonly tokenAuth: TokenAuthAppService;
  public readonly user: UserAppService;
  public readonly vehicleAds: VehicleAdsAppService;
  public readonly vehicleDocument: VehicleDocumentAppService;
  public readonly vehicleExpenses: VehicleExpensesAppService;
  public readonly vehicleImage: VehicleImageAppService;
  public readonly vehicleInternalObservations: VehicleInternalObservationsAppService;
  public readonly vehicleManagementInfos: VehicleManagementInfosAppService;
  public readonly vehicles: VehiclesAppService;
  public readonly vehicleSale: VehicleSaleAppService;
  public readonly vendors: VendorsAppService;

  public readonly request: BaseHttpRequest;

  constructor(
    config?: Partial<OpenAPIConfig>,
    HttpRequest: HttpRequestConstructor = AxiosHttpRequest,
  ) {
    this.request = new HttpRequest({
      BASE: config?.BASE ?? "",
      VERSION: config?.VERSION ?? "frontend/v1",
      WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
      CREDENTIALS: config?.CREDENTIALS ?? "include",
      TOKEN: config?.TOKEN,
      USERNAME: config?.USERNAME,
      PASSWORD: config?.PASSWORD,
      HEADERS: config?.HEADERS,
      ENCODE_PATH: config?.ENCODE_PATH,
    });

    this.autoline = new AutolineAppService(this.request);
    this.autoShopping = new AutoShoppingAppService(this.request);
    this.cache = new CacheAppService(this.request);
    this.carroSp = new CarroSpAppService(this.request);
    this.chavesNaMao = new ChavesNaMaoAppService(this.request);
    this.configuration = new ConfigurationAppService(this.request);
    this.contracts = new ContractsAppService(this.request);
    this.credentials = new CredentialsAppService(this.request);
    this.dashboard = new DashboardAppService(this.request);
    this.entity = new EntityAppService(this.request);
    this.entityAdditionalInfos = new EntityAdditionalInfosAppService(
      this.request,
    );
    this.entityDocument = new EntityDocumentAppService(this.request);
    this.facebook = new FacebookAppService(this.request);
    this.financialCategory = new FinancialCategoryAppService(this.request);
    this.financialMovement = new FinancialMovementAppService(this.request);
    this.iCarros = new ICarrosAppService(this.request);
    this.mercadoLivre = new MercadoLivreAppService(this.request);
    this.mobiauto = new MobiautoAppService(this.request);
    this.netMotors = new NetMotorsAppService(this.request);
    this.olx = new OlxAppService(this.request);
    this.permissions = new PermissionsAppService(this.request);
    this.portals = new PortalsAppService(this.request);
    this.premium = new PremiumAppService(this.request);
    this.role = new RoleAppService(this.request);
    this.salaoDoCarro = new SalaoDoCarroAppService(this.request);
    this.session = new SessionAppService(this.request);
    this.soCarrao = new SoCarraoAppService(this.request);
    this.tags = new TagsAppService(this.request);
    this.tokenAuth = new TokenAuthAppService(this.request);
    this.user = new UserAppService(this.request);
    this.vehicleAds = new VehicleAdsAppService(this.request);
    this.vehicleDocument = new VehicleDocumentAppService(this.request);
    this.vehicleExpenses = new VehicleExpensesAppService(this.request);
    this.vehicleImage = new VehicleImageAppService(this.request);
    this.vehicleInternalObservations =
      new VehicleInternalObservationsAppService(this.request);
    this.vehicleManagementInfos = new VehicleManagementInfosAppService(
      this.request,
    );
    this.vehicles = new VehiclesAppService(this.request);
    this.vehicleSale = new VehicleSaleAppService(this.request);
    this.vendors = new VendorsAppService(this.request);
  }
}
